import { render, staticRenderFns } from "./header-index.vue?vue&type=template&id=09e17a76&scoped=true"
import script from "./header-index.vue?vue&type=script&lang=js"
export * from "./header-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e17a76",
  null
  
)

export default component.exports